import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import c from 'classnames';

import './_inputNew.scss';

const InputNew = ({
                    id,
                    name,
                    value,
                    label,
                    placeholder,
                    helpText,
                    type = 'text',
                    disabled = false,
                    error,
                    className = '',
                    autoComplete = 'off',
                    readOnly = false,
                    autoFocus = false,
                    onChange,
                    onFocus,
                    onBlur,
                    size = 'medium',
                    icon,
                    endIcon,
                    prefix,
                    suffix,
                    step,
                    min,
                    onKeyDown
}) => {
  const inputRef = useRef(null);
  const [focused, setFocused] = useState(false);
  // const [hiddenValue, setHiddenValue] = useState('');
  const inputContainerClass = c('inputNew-container', className, size, { 'icon': icon, disabled, error });
  const inputLabelClass = c('inputNew-label', { error });
  const inputWrapperClass = c('inputNew-wrapper', size, { disabled, error, focused, 'with-prefix': prefix });
  const inputIconClass = c('inputNew-icon', { disabled, error });
  const inputEndIconClass = c(inputIconClass, 'end');
  const inputFieldClass = c('inputNew-field', { error, disabled, 'with-suffix': suffix });
  const inputHelpClass = c('inputNew-help', { error });

  return (
    <div className={inputContainerClass}>
      {label && <label className={inputLabelClass}>{label}</label>}
      <div className={inputWrapperClass}>
        {icon && <span className={inputIconClass}>{icon}</span>}
        {(prefix || suffix) ? (
          <>
            {prefix && <span className="prefix" onClick={() => inputRef.current && inputRef.current.focus()}>{prefix}</span>}
            <div className={inputFieldClass}>
              <input
                ref={inputRef}
                id={id}
                name={name}
                value={value}
                type={type}
                step={step}
                min={min}
                readOnly={readOnly}
                autoComplete={autoComplete}
                disabled={disabled}
                placeholder={placeholder}
                autoFocus={autoFocus}
                onChange={e => {
                  onChange(e);
                  // setHiddenValue(e.target.value);
                }}
                onKeyDown={onKeyDown}
                onWheel={type === 'number' ? e => e.target.blur() : undefined}
                onFocus={e => {
                  setFocused(true);
                  onFocus && onFocus(e);
                }}
                onBlur={e => {
                  setFocused(false);
                  onBlur && onBlur(e);
                }}
              />
              {suffix && (
                <div className="suffix-container">
                  <span className="hidden-value">{value}</span>
                  <span className="suffix" onClick={() => inputRef.current && inputRef.current.focus()}>{suffix}</span>
                </div>
              )}
            </div>
          </>
        ) : (
          <input
            ref={inputRef}
            id={id}
            name={name}
            value={value}
            type={type}
            step={step}
            min={min}
            readOnly={readOnly}
            autoComplete={autoComplete}
            disabled={disabled}
            placeholder={placeholder}
            autoFocus={autoFocus}
            onChange={onChange}
            onKeyDown={onKeyDown}
            onWheel={type === 'number' ? e => e.target.blur() : undefined}
            className={inputFieldClass}
            onFocus={e => {
              setFocused(true);
              onFocus && onFocus(e);
            }}
            onBlur={e => {
              setFocused(false);
              onBlur && onBlur(e);
            }}
          />
        )}
        {endIcon && <span className={inputEndIconClass}>{endIcon}</span>}
      </div>
      {(helpText || error) && <p className={inputHelpClass}>{error ? error : helpText}</p>}
    </div>
  );
};

InputNew.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  label: PropTypes.string,
  autoComplete: PropTypes.string,
  readOnly: PropTypes.bool,
  placeholder: PropTypes.string,
  helpText: PropTypes.string,
  type: PropTypes.oneOf(['text', 'number']),
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  autoFocus: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  size: PropTypes.oneOf(['large', 'medium']),
  icon: PropTypes.node,
  endIcon: PropTypes.node,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  step: PropTypes.string,
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onKeyDown: PropTypes.func
};

export default InputNew;